<template>
  <div class="headlines">
    <div class="row-wrap">
      <el-row :gutter="10">
        <el-col :span="18">
          <div class="banner-wrap">
            <el-carousel height="340px">
              <el-carousel-item v-for="(ban, b) in banners"
                                :key="b">
                <img width="100%"
                     height="100%"
                     :src="ban.url"
                     alt="">
              </el-carousel-item>
            </el-carousel>

            <div class="article-list">
              <div class="article-item"
                   v-for="(ch, c) in articlesList"
                   :key="c">
                <div class="deliver-img">
                  <img :src="ch.cover"
                       alt="">
                </div>
                <div class="deliver-con"
                     :style="{'width': 'calc(100% - 212px)',
                        'padding-left': '16px'}">
                  <div class="max-name">
                    <span class="name"
                          @click="info(ch)">{{ch.title}}</span>
                  </div>
                  <div class="max-text">{{ch.description}}</div>

                  <div class="other">
                    <div class="tag">
                      <img src="../assets/img/icon/tag.png"
                           alt="">
                      <div class="tag-box">
                        <span class="tag-item"
                              v-for="(label, l) in ch.keywords"
                              :key="l">{{label}}</span>
                      </div>
                    </div>
                    <div class="data">
                      <span class="number">
                        <img src="../assets/img/icon/eye.png"
                             alt="">
                        {{ch.viewCount || 0}}
                      </span>
                      <span>
                        <img src="../assets/img/icon/time.png"
                             alt="">
                        {{ch.createTime}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <el-pagination style="text-align: center"
                           @size-change="pageSize"
                           @current-change="currentPage"
                           :current-page="currentPage"
                           :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
                           :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="code-advert">
            <img src="../assets/img/headlines/wxCode.jpg"
                 alt="">
            <img src="../assets/img/headlines/user.png"
                 alt="总裁讲座定制">
          </div>

          <div class="contact">
            <p>想建供应链平台 就找海平老师</p>
            <p>微信号sz_scm</p>
          </div>

          <div class="customer">
            <div v-for="(cus, c) in customers"
                 :key="c"
                 @click="openUrl(cus.url)"
                 class="customer-item">
              <img :src="cus.logo"
                   alt="">
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
export default {
  name: 'headlines',
  data () {
    return {
      banners: [
        { url: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/A9446AE1F9D5D7AF.jpg' },
        { url: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/banner_headlines.jpg' },
        { url: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/07E4FA6D932F0ACD.jpg' },
        { url: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/F6D43AAEF66B0359.jpg' }
      ],
      customers: [
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/0A7479B5E691CB87.png', url: 'http://www.dachuangtech.com/#/index' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/6CE4961C58589425.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/22A4B673F656C3C7.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/0F74BDB4E4F7ECDB.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/B83426CD96E82DFE.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/16D45AF39AB56141.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/2B4459C8254471B8.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/5644128A24F52C3E.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/CA2492AFEF7BB891.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/44748258201B5772.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/2C147D64D375EA1B.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/4B649F49B7FB1BB5.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/4FC443ED196E1481.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/FD841BB5A68557FF.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/34F4AB6E69576B28.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/40149AD0A17AEE17.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/89E44AE28537CDA5.png', url: '' },
        { name: '', logo: 'https://lambor.oss-cn-shenzhen.aliyuncs.com/BFD40075AEDB3668.png', url: '' }
      ],
      articlesList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted () {
    this.getArticles()
  },
  methods: {
    openUrl (url) {
      url && window.open(url)
    },
    info (val) {
      let routeData = this.$router.resolve({
        name: 'articleInfo',
        query: { id: val.id }
      })
      window.open(routeData.href, '_blank')
    },
    getArticles () {
      this.$http({
        method: 'post',
        url: this.$http.adornUrl('/crmapi/dccms/article/list'),
        timeout: 20000,
        data: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          categoryId: 6549082170130432
        }
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          let array = data.result.list || []
          this.articlesList = array.map(item => {
            item.keywords = item.keywords ? item.keywords.split(',') : []
            return item
          })
          this.total = data.result.total
        }
      })
    },
    sizeChange (size) {
      this.pageSize = size
      this.getArticles()
    },
    currentChange (currPage) {
      this.currentPage = currPage
      this.getArticles()
    }
  }
}
</script>

<style lang="scss" scoped>
.article-list {
  margin: 12px 0;
  .article-item {
    background: #fff;
    display: flex;
    justify-content: space-between;
    border: 1px solid #eeeeee;
    box-sizing: border-box;
    box-shadow: 0px 8px 8px 8px rgba(221, 221, 221, 0.1);
    font-size: 14px;
    padding: 16px 10px;
    margin-top: 8px;
    .deliver-img {
      width: 212px;
      height: 136px;
      img {
        width: 212px;
        height: 136px;
        border-radius: 8px;
      }
    }
    .deliver-con {
      line-height: 25px;
      box-sizing: border-box;
      .other {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        img {
          width: 20px;
          height: 20px;
          vertical-align: -0.3em;
        }
        .tag {
          flex: 1;
          display: flex;
          .tag-box {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .tag-item {
          display: inline-block;
          border: 1px solid #f4f4f4;
          box-sizing: border-box;
          border-radius: 4px;
          font-size: 12px;
          line-height: 16px;
          padding: 4px 6px;
          color: #1d74ff;
          margin: 0 6px;
        }
        .data {
          font-size: 14px;
          color: #888;
          width: 238px;
          .number {
            color: #555;
            display: inline-block;
            width: 70px;
          }
        }
      }
      .max-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        padding-right: 40px;
        .name:hover {
          color: #0078ff;
        }
        .star {
          position: absolute;
          right: 0;
          top: -3px;
        }
      }
      .max-text {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    .max-name {
      font-size: 20px;
      color: #222;
      cursor: pointer;
    }
    .max-text {
      margin-top: 10px;
      font-size: 14px;
      line-height: 24px;
      color: #555;
      height: 48px;
      overflow: hidden;
    }
    .max-date {
      width: 86px;
      font-size: 12px;
      color: #bdc8d6;
    }
    .user-option {
      line-height: 50px;
      span {
        display: inline-block;
        width: 75px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        color: #fff;
        font-size: 12px;
        border-radius: 13px;
        cursor: pointer;
      }
      span:first-child {
        background: #1ad7db;
        margin-right: 10px;
      }
      span:first-child:hover {
        background: #6dd3d5;
      }
      span:last-child {
        background: #0d91ff;
      }
      span:last-child:hover {
        background: #5eb5fe;
      }
    }
    .user-info {
      width: 220px;
      display: flex;
      .user-pic {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
      .info-text {
        line-height: 25px;
        margin-left: 12px;
        flex: 1;
      }
    }
    .user-tel {
      width: 200px;
      line-height: 50px;
      color: #8a94a8;
    }
    .user-honor {
      width: 140px;
      line-height: 50px;
      color: #499efe;
      i {
        color: #ffc500;
        margin-right: 12px;
      }
    }
  }
}
.headlines {
  background: #e5e5e5;
  .row-wrap {
    width: 1190px;
    margin: auto;
    padding: 10px 0;
  }
}
.code-advert {
  padding: 10px;
  background: #fff;
  img {
    width: 100%;
  }
}
.contact {
  background: #f88d0b;
  color: #fff;
  text-align: center;
  padding: 20px 0;
  margin-top: 10px;
  p {
    margin: 10px 0;
  }
  p:first-child {
    font-size: 16px;
  }
  p:last-child {
    font-size: 14px;
  }
}
.customer {
  margin-top: 10px;
}
.customer-item {
  width: 100%;
  height: 90px;
  background: #fff;
  margin-bottom: 1px;
  text-align: center;
  line-height: 90px;
  cursor: pointer;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/headlines.vue